const API_BASE = process.env.REACT_APP_API_URL || '';

interface RequestOptions {
  method?: string;
  body?: unknown;
  headers?: Record<string, string>;
}

class ApiClient {
  private getToken(): string | null {
    return localStorage.getItem('access_token');
  }

  async request<T>(path: string, options: RequestOptions = {}): Promise<T> {
    const token = this.getToken();
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE}${path}`, {
      method: options.method || 'GET',
      headers,
      body: options.body ? JSON.stringify(options.body) : undefined,
    });

    if (response.status === 401) {
      // Token expired — redirect to sign in
      localStorage.removeItem('access_token');
      window.location.href = '/';
      throw new Error('Unauthorized');
    }

    if (response.status === 429) {
      const data = await response.json();
      const error = new Error('Rate limit exceeded') as Error & { retryAfter: number };
      error.retryAfter = data.retryAfter || 60;
      throw error;
    }

    if (!response.ok) {
      const data = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(data.detail || `HTTP ${response.status}`);
    }

    return response.json();
  }

  get<T>(path: string): Promise<T> {
    return this.request<T>(path);
  }

  post<T>(path: string, body?: unknown): Promise<T> {
    return this.request<T>(path, { method: 'POST', body });
  }
}

export const api = new ApiClient();
